import firebase from "../firebase/index";
//import {deserialize, serialize} from "serializr";
//import {User} from "../app/product/User";
//import {consoleWarn} from "vuetify/lib/util/console";

// const DB_ROOT_PATH = "";
//
// let database = {
//     namespaced: true,
//     state: {
//         mProducts: [],
//     },
//     mutations: {
//         setProducts(state, products) {
//             state.mProducts = products;
//         },
//         updateProduct(state, product) {
//             // for (let item of state.mProducts) {
//             //     item.changed = false;
//             // }
//             //
//             // product.changed = true;
//             //
//             // // let index = state.mProducts.findIndex(v => {
//             // //     return v.uid === product.uid;
//             // // });
//             //
//             // if (index >= 0) {
//             //     state.mProducts.splice(index, 1, product);
//             // } else {
//             //     state.mProducts.push(product);
//             // }
//         }
//     },
//     getters: {
//         getProducts: state => {
//             return state.mProducts;
//         }
//     },
//     actions: {
//         load({/*dispatch,*/ commit}) {
//             return Promise.all([
//                 firebase
//                     .firestore()
//                     .ref(DB_ROOT_PATH + "/")
//                     .once("value", function (snapshot) {
//                         let values = Object.values(snapshot.val() || {});
//                         let data = values.map(v => deserialize(User, v));
//                         commit("setProducts", data);
//                     })
//             ]).then(() => {
//                 //dispatch("pushItems");
//             })
//         },
//         clear({commit}) {
//             commit("setProducts", []);
//             return Promise.resolve();
//         },
//         pushProducts({state}) {
//             // let path = DB_ROOT_PATH /* + "/products"*/;
//             // let data = state.mProducts.reduce((result, item) => {
//             //     result[item.uid] = serialize(User, item);
//             //     return result;
//             // }, {});
//             // return firebase
//             //     .database()
//             //     .ref(path)
//             //     .set(data, error => {
//             //         if (error) {
//             //             console.error("publish products failed: " + error);
//             //         }
//             //     });
//         },
//         pushProduct({commit}, product) {
//             // let path = DB_ROOT_PATH + "/products/" + product.uid;
//             // let data = serialize(User, product);
//             // return firebase
//             //     .database()
//             //     .ref(path)
//             //     .set(data, error => {
//             //         if (error) {
//             //             console.error("publish product failed: " + error);
//             //         } else {
//             //             commit("updateProduct", product);
//             //         }
//             //     });
//         }
//     }
// }

const database = firebase.firestore();
// database.settings({
//     timestampsInSnapshots: true,
// });

export default database;
